<p-menubar class="p-menubar-primary" class="" [model]="items" appCustomMenuItemTooltip [options]="items">
  <a class="app-logo" routerLink="/">
    <img class="full-logo" height="34" runat="server" src="assets/images/eurofins-logo-primary.png" alt="Eurofins logo">
  </a>
</p-menubar>